// {@see CdnParser}

module.exports = {
  parsers: [{
    element: 'name',
    headerName: null,
    regex: /(.+)/
  }]
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/youboralib/src/comm/transform/resourceparsers/cdnparsers/balancer.js
// module id = 721
// module chunks = 0